export const extractNumericRate = rate => {
  return rate.replace(/[^\d.]/g, '').trim();
};
//# sourceMappingURL=extractNumericRate.js.map